import { Outlet } from "react-router-dom";

const Tech = () => {
  return (
    <>
      <>
        <Outlet />
      </>
    </>
  );
};

export default Tech;
